window.utilWelcomeOffer = function (
  offerBody,
  offerAmount,
  offerCode,
  override = false
) {
  const offerDetails = {
    body: offerBody,
    code: offerCode,
    amount: offerAmount,
  };
  window.offerDetails = {
    discountCode: offerCode,
    discountAmount: offerAmount,
  };
  if (!window.localStorage.getItem("welcome_offer")) {
    window.localStorage.setItem("welcome_offer", JSON.stringify(offerDetails));
  } else if (override) {
    window.localStorage.setItem("welcome_offer", JSON.stringify(offerDetails));
  }
  // Disconnect existing observer if it exists
  if (window._welcomeOfferObserver) {
    window._welcomeOfferObserver.disconnect();
    window._welcomeOfferObserver = null;
  }
  // Clear existing debounce timer if it exists
  if (window._welcomeOfferDebounceTimer) {
    clearTimeout(window._welcomeOfferDebounceTimer);
    window._welcomeOfferDebounceTimer = null;
  }

  const BODY_SELECTOR = "span[data-welcome-offer-body]";
  const CODE_SELECTOR = "span[data-welcome-offer-code]";
  const AMOUNT_SELECTOR = "span[data-welcome-offer-amount]";

  function replaceOfferBody(el) {
    if (el.dataset.offerBodyReplaced && !override) return;
    el.innerHTML = offerDetails.body;
    el.dataset.offerBodyReplaced = "true";
  }
  function replaceOfferCode(el) {
    if (el.dataset.offerCodeReplaced && !override) return;
    el.innerHTML = offerDetails.code;
    el.dataset.offerCodeReplaced = "true";
  }
  function replaceOfferAmount(el) {
    if (el.dataset.offerAmountReplaced && !override) return;
    el.innerHTML = offerDetails.amount;
    el.dataset.offerAmountReplaced = "true";
  }

  function handleInitialElements() {
    document
      .querySelectorAll(BODY_SELECTOR)
      .forEach((el) => replaceOfferBody(el));
    document
      .querySelectorAll(CODE_SELECTOR)
      .forEach((el) => replaceOfferCode(el));
    document
      .querySelectorAll(AMOUNT_SELECTOR)
      .forEach((el) => replaceOfferAmount(el));

    if (!document.cookie.includes(`discount_code=${offerDetails.code}`)) {
      document.cookie = "discount_code=remove; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      
      fetch(
        `https://www.lookoptic.com/discount/${offerDetails.code}`
      );
    }
    document.documentElement.classList.add('welcome-offer-active');
  }

  // Debounced processing function
  function processQueuedNodes() {
    if (
      window._welcomeOfferNodeQueue &&
      window._welcomeOfferNodeQueue.length > 0
    ) {
      const nodes = [...window._welcomeOfferNodeQueue];
      window._welcomeOfferNodeQueue = [];

      nodes.forEach((node) => {
        try {
          if (node.nodeType !== 1) return;
          if (node.matches?.(BODY_SELECTOR)) {
            replaceOfferBody(node);
          } else if (node.matches?.(CODE_SELECTOR)) {
            replaceOfferCode(node);
          } else if (node.matches?.(AMOUNT_SELECTOR)) {
            replaceOfferAmount(node);
          }
          node
            .querySelectorAll?.(BODY_SELECTOR)
            .forEach((child) => replaceOfferBody(child));
          node
            .querySelectorAll?.(CODE_SELECTOR)
            .forEach((child) => replaceOfferCode(child));
          node
            .querySelectorAll?.(AMOUNT_SELECTOR)
            .forEach((child) => replaceOfferAmount(child));
        } catch (e) {
          console.warn("Welcome offer replacement error:", e);
        }
      });
    }
  }

  function observeNewElements() {
    // Initialize node queue
    window._welcomeOfferNodeQueue = [];

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          // Add nodes to queue instead of processing immediately
          window._welcomeOfferNodeQueue.push(node);
        });
      });

      // Clear existing timer and set new one
      if (window._welcomeOfferDebounceTimer) {
        clearTimeout(window._welcomeOfferDebounceTimer);
      }

      // Process queued nodes after 50ms of inactivity
      window._welcomeOfferDebounceTimer = setTimeout(() => {
        processQueuedNodes();
        window._welcomeOfferDebounceTimer = null;
      }, 50);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    // Store reference to the observer globally so we can clean it up later
    window._welcomeOfferObserver = observer;
  }

  function waitForElementToDisplay(
    selector,
    callback,
    interval = 100,
    timeout = 10000
  ) {
    const start = Date.now();
    const timer = setInterval(() => {
      if (document.querySelector(selector)) {
        clearInterval(timer);
        callback();
      } else if (Date.now() - start > timeout) {
        clearInterval(timer);
        console.warn(
          `waitForElementToDisplay: Timed out waiting for ${selector}`
        );
      }
    }, interval);
  }
  waitForElementToDisplay(
    BODY_SELECTOR,
    () => {
      handleInitialElements();
      observeNewElements();
    },
    100,
    10000
  );
};

if (window.localStorage.getItem("welcome_offer")) {
  const offerJson = JSON.parse(window.localStorage.getItem("welcome_offer"));
  window.utilWelcomeOffer(offerJson.body, offerJson.amount, offerJson.code);
}
